import * as React from 'react'
import { Alert, Box, Button, Checkbox, CircularProgress, FormControl, FormLabel, Grid, Input, Link, Modal, ModalDialog, Stack, Table, Textarea, Tooltip, Typography } from "@mui/joy"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { toggleAddScript, toggleEditScript, triggerCarregaListaScripts, triggerDeletarScript, triggerFormAddProcessar, triggerFormEdicaoProcessar, triggerVerificaDisponibilidadeServidorRunner, updateFormAddAttr } from "./ScriptManagerSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDateJavaComHoras } from '../helper/functions';
import { Link as LinkRouter } from "react-router-dom"
import { novaConfirmacao, startConfirmacao } from '../helper/confirmation-modal/confirmationSlice';
import EditIcon from '@mui/icons-material/Edit';
import DisponibilidadeIcon from '../core/components/DisponibilidadeIcon';
import { displayGeneralDetail } from '../helper/general-details/GeneralDetailSlice';

function ScriptManager() {

    var dispatch = useDispatch()
    var disponibilidade = useSelector((state) => state.scripts.disponibilidade)
    var data = useSelector((state) => state.scripts.lista)

    React.useEffect(() => {
        dispatch(triggerVerificaDisponibilidadeServidorRunner())
        dispatch(triggerCarregaListaScripts())
    }, []);

    var toggleModalScript = () => {
        dispatch(toggleAddScript())
    }

    var deletar = (id) => {
        dispatch(triggerDeletarScript(id))
    }

    var toggleEditTodo = (id) => {
        dispatch(toggleEditScript(id))
    }

    return <Grid sx={{ padding: "10px" }} >
        <ModalNovoScript close={toggleModalScript} />
        <Stack>
            <Box>
                <Stack direction={"row"} spacing={2}>
                    <Typography>
                        <b>Disponibilidade:</b> runner.anano.com.br
                    </Typography>
                    <DisponibilidadeIcon disp={disponibilidade} />
                </Stack>
            </Box>
            <Grid style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Stack direction={"row"} spacing={5}>
                    <LinkRouter to="/notetaker/editor/56bac4b6-7c7d-4a5f-8087-361413b03c4f" >Notas do script runner</LinkRouter>
                    <LinkRouter to="/scripts/agendamentos" >Agendamentos</LinkRouter>
                </Stack>
            </Grid>
            <Grid>
                <Button color='danger' onClick={toggleModalScript}>Adicionar Script</Button>
            </Grid>
            <Grid style={{ padding: "10px" }}>
                <Box>
                    <Table size="small" aria-label="striped table" stripe={"odd"}>
                        <thead>
                            <tr>
                                <th style={{ width: "15%", textAlign: "left" }}>Criação</th>
                                <th style={{ textAlign: "left", width: "5%" }}>ID</th>
                                <th style={{ textAlign: "left", width: "5%" }}>Edit</th>
                                <th style={{ textAlign: "left" }}>Notas</th>
                                <th style={{ width: "3%", textAlign: "center" }}>X</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {console.log("123", typeof(data))} */}
                            {


                                data
                                    .filter((row) => row.dataCancelamento == null)
                                    .map((row) => {
                                        return <tr key={row.id} className='nova_linha'>
                                            <td style={{ padding: "2px 0px" }}>
                                                {formatDateJavaComHoras(row.dataCadastro)}
                                            </td>
                                            <td style={{ padding: "2px 0px" }}>
                                                <Link onClick={() => dispatch(displayGeneralDetail(row.id))
                                                }>{"ID"}</Link>
                                            </td>
                                            <td style={{ padding: "2px 0px" }}>
                                                <EditIcon onClick={() => toggleEditTodo(row.id)} style={{ cursor: "pointer" }} />
                                            </td>
                                            <td style={{ padding: "2px 0px" }}>
                                                <LinkRouter to={"/scripts/" + row.id}>
                                                    {row.nome}
                                                </LinkRouter>
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <Link onClick={() => {
                                                    dispatch(startConfirmacao(novaConfirmacao("Deseja remover esse script?", () => deletar(row.id))))
                                                }} className='link_remove' style={{ color: "#C20000", display: "none" }}>[ x ]</Link>
                                            </td>
                                        </tr>
                                    })}
                        </tbody>
                    </Table>
                </Box>
            </Grid>
        </Stack>
    </Grid>
}


function ModalNovoScript(props) {

    var dispatch = useDispatch()
    var form = useSelector((state) => state.scripts.formAdd)
    var isOpen = form.isOpen
    var erro = form.erro
    var nome = form.nome
    var ehEdicao = form.edit != false
    var processando = form.processando
    var close = props.close
    var salvar = () => {

        if (form.nome.trim().length < 3) {
            updateAttribute("erro", "Nome inválido ou muito curto")
        } else if (!ehEdicao && (form.arquivo == null || !form.arquivo.name.includes(".zip"))) {
            updateAttribute("erro", "Upload exige arquivo zipado")
        } else {

            if (!ehEdicao)
                dispatch(triggerFormAddProcessar())
            else
                dispatch(triggerFormEdicaoProcessar())
        }

    }
    var updateAttribute = (campo, valor) => {
        // console.log(campo, valor)
        dispatch(updateFormAddAttr({
            campo: campo,
            value: valor
        }))
    }

    var updateArquivo = (e) => {

        if (!e.target.files[0].name.includes(".zip")) {
            updateAttribute("erro", "Upload exige arquivo zipado")
        } else {
            updateAttribute("arquivo", e.target.files[0])
        }

    }

    function ErroDisplay(props) {
        if (props.erro == null || props.erro.length == 0) {
            return ""
        }

        return <Alert variant={"soft"} color="danger">
            {props.erro}
        </Alert>
    }

    function InfoDisplay(props) {

        return <LinkRouter to="/notetaker/editor/56bac4b6-7c7d-4a5f-8087-361413b03c4f" >Nota: O que precisa saber para rodar o script)</LinkRouter>
    }

    return <Modal open={isOpen} onClose={close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 500 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                {ehEdicao ? "Alterar script" : "Novo Script"}
            </Typography>
            <Stack spacing={2}>
                <ErroDisplay erro={erro} />
                <InfoDisplay />
                <Input placeholder="Nome..." type="text" value={nome} autoFocus disabled={processando} onChange={(e) => updateAttribute("nome", e.target.value)}></Input>
                {/* <Checkbox onChange={() => updateValue("default", !dfault)} label="Lista padrao" ></Checkbox> */}
                <FormControl>
                    <FormLabel>Arquivo</FormLabel>
                    <Input disabled={processando} name="file" type="file" onChange={(e) => updateArquivo(e)} />
                </FormControl>
                <Box sx={{
                    textAlign: "right"
                }}>
                    <Button onClick={salvar} disabled={processando}>{
                        processando ? "Salvando..." : "Salvar"
                    }</Button>
                </Box>
            </Stack>
        </ModalDialog>
    </Modal>
}

export default ScriptManager